import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_tecfad.png",
      alt: "Estratégias INFRATECIA",
    },
    title: "Seja um investidor inteligente com a INFRATECIA",

    // String ou array de strings
    text: [
      "A INFRATECIA é a escolha certa para investidores que buscam segurança, rentabilidade e tranquilidade em seus investimentos. Há vários anos no empenho de transformar o mercado financeiro em uma oportunidade lucrativa para todos, nossa experiência e dedicação nos levaram a um alto patamar, nossa equipe de especialistas desenvolve robôs de inteligência artificial com estratégias avançadas para garantir resultados consistentes e satisfatórios.",
      "Milhares de clientes satisfeitos experimentaram a eficiência da INFRATECIA. Nós acreditamos que investir em seu futuro financeiro não deve ser algo complicado e arriscado. Por isso, trabalhamos incansavelmente para proporcionar aos nossos clientes uma experiência de investimento tranquila e eficiente.",
      "Em um clique nós cuidamos das suas operações para obter excelentes resultados. Nossos Robôs podem transformar sua vida financeira hoje mesmo.",
    ],
    testimonial: {
      text: "O sucesso financeiro começa com decisões inteligentes e constroem um futuro brilhante diante da consistência nas escolhas ao longo do tempo.",
      author: {
        name: "Hamilton Fradinho – CEO INFRATECIA",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Estratégias com Inteligência Artificial",
    heading:
      "Transforme seus investimentos com o poder dos nossos robôs desenvolvidos com Inteligência Artificial",
    subtitle:
      "Conheça nossos robôs de IA que estão disponíveis para transformar sua vida financeira.",
  },

  cta: {
    title: "Comece seu investimento inteligente",
    subtitle: "Ative a extensão da INFRATECIA IAS",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A INFRATECIA",
    col1: [
      "A INFRATECIA é uma empresa apaixonada e obstinada pelo que faz, com mais de 20 anos de experiência no desenvolvimento de produtos com excelência (Plataforma, Sistemas, Games, Apps, dentre outros). Vários utilizam Algoritmos complexos para análise de dados, Machine Learning e Inteligências Artificiais.",
      "Agora projeta todo seu know how às Inteligências Artificiais aplicadas ao mercado financeiro. Acreditamos que todos merecem ter acesso a soluções avançadas de investimento, sendo assim, nos dedicamos a desenvolver robôs utilizando técnicas avançadas de Deep Learning, Inteligência artificial de alto desempenho*, para que esses tornem os seus sonhos em realidade.",
    ],
    col2: [
      "Nossa equipe é formada por especialistas apaixonados que trabalham juntos com um único objetivo: oferecer uma experiência de investimento única, segura e rentável. Acreditamos que a inovação e as novas realidades diante do desenvolvimento da Inteligência Artificial, compõem a chave para o sucesso financeiro. Estamos sempre em busca de novas soluções para tornar realidade os objetivos dos nossos Clientes. Em nossa missão, acreditamos em um “futuro financeiro brilhante” e estamos dispostos a trabalhar obstinadamente para torná-lo realidade.",
      "* Alguns dos nossos modelos de inteligência artificial analisam mais de 10.000.000 de parâmetros com mais de 20 indicadores antes de finalizarem os robôs. ",
    ],
  },

  stats: {
    title: "A excelência se mede nos resultados alcançados",
    subtitle:
      "Não há limites para o seu potencial financeiro. Escolha a INFRATECIA e alcance o sucesso que sempre sonhou no trade.",
    data: [
      {
        value: "+5",
        description: "Milhões de parâmetros gerados pela IA",
      },
      {
        value: "+1000",
        description: "Operações lucrativas em dois anos de backtests",
      },
      {
        value: "+20",
        description:
          "Indicadores gráficos analisados simultaneamente para tomada de decisão.",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da INFRATECIA?",
    subtitle: "Veja quais as principais vantagens dos robôs da INFRATECIA.",
    data: [
      {
        icon: iconsSet.preference,
        title: "Redução dos Riscos",
        description:
          "Nossa IA é treinada para identificar as melhores oportunidades minimizando riscos potenciais, inclusive notícias econômicas ou políticas, protegendo seu investimento de qualquer perigo.",
      },
      {
        icon: iconsSet.memory,
        title: "Decisões Assertivas",
        description:
          "Com a IAS treinadas, algoritmos avançados e processamento de dados em tempo real, buscamos decisões precisas e lucrativas.",
      },
      {
        icon: iconsSet.growth,
        title: "Lucros Consistentes",
        description:
          "A IA decide baseada em análises objetivas e dados concretos, minimizando assim distorções ocasionadas por emoções e impulsos (natural do ser humano), buscando resultados com tomadas de decisão mais estáveis.",
      },
      {
        icon: iconsSet.calendar,
        title: "Sem necessidade de conhecimento técnico",
        description:
          "Nossa IA cuidará de tudo por você! Não precisa ser um expert em bolsa de valores, mercado financeiro e controle emocional.",
      },
      {
        icon: iconsSet.favorite,
        title: "Menos stress",
        description:
          "Nossas estratégias, valores de Loss e Gain, aplicadas pela IA, estão sempre atentas para reduzir os riscos e agir com precisão. Auxiliando, por exemplo, em horários com notícias, flutuações do mercado, dentre outros.",
      },
      {
        icon: iconsSet.clock,
        title: "Mais tempo livre",
        description:
          "Ao delegar as operações de investimento para nossa IA, você terá mais tempo para se concentrar em outras coisas importantes na sua vida, enquanto nosso robô fará tudo de forma 100% automatizada por você.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão INFRATECIA",
  },

  // testimonials: [
  //   {
  //     text: "A Newbot é muito mais que estratégias para robôs que realmente funcionam, é atendimento especializado, orientação plena e aprendizado. Parabéns Edson e equipe!",
  //     author: "Eliseu Sandres",
  //     job: "Bancário",
  //     image_url:
  //       "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Além de possuir estratégias extremamente bem refinadas, a Newbot proporciona também conhecimento compartilhado, atendimento direto e rápido e verdadeira preocupação com seus clientes.",
  //     author: "Victor Nardi Vilella",
  //     job: "Arquiteto de Sistemas",
  //     image_url:
  //       "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],
};
